// ========================================
// NOUVEAU FICHIER À CRÉER
// Emplacement : src/components/settings/ModulePermissionsTab.js
// ========================================

import React from 'react';
import ModulePermissionsManager from './ModulePermissionsManager';
import { useAuth } from '../../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';

const ModulePermissionsTab = () => {
  const { currentUser } = useAuth();

  // Seulement accessible aux admins
  if (currentUser?.role !== 'admin') {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        <AlertCircle className="mx-auto text-red-500 mb-4" size={48} />
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">
          Accès Restreint
        </h3>
        <p className="text-gray-600 dark:text-gray-400">
          Cette fonctionnalité est réservée aux administrateurs.
        </p>
      </div>
    );
  }

  return <ModulePermissionsManager />;
};

export default ModulePermissionsTab;
